import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TdoImagePickerEvent} from '../common/tdo-image-picker/model/tdo-image-picker.event';
import {TdoImagePickerComponent} from '../common/tdo-image-picker/tdo-image-picker.component';

@Component({
  selector: 'tdo-user-icon-selector',
  templateUrl: './tdo-user-icon-selector.component.html',
  styleUrls: ['./tdo-user-icon-selector.component.scss']
})
export class TdoUserIconSelectorComponent implements OnInit {
  @Input() value: string;
  @Output() imageChange = new EventEmitter<TdoImagePickerEvent>();

  path = 'assets/icons/user/';

  dataSource: string[] = ['icons8-user-female-skin-type-5.svg', 'icons8-user-male.svg'];

  constructor() { }

  ngOnInit(): void {
  }

  onImageChange(event: TdoImagePickerEvent) {
    this.imageChange.emit(event);
  }
}
